<template>
	<div>
		<div class="common_box_tit">
			<div>相关问答</div>
			<div class="bom_line"></div>
		</div>
		<!-- <div class="xxwd" v-for="(it,i) in 10" :key="i">
			<div class="yuan"></div>
			<div class="single">
				我公司是按月申报的增值税小规模纳税人，2023年1月份预计销售货物取得收入20万元，请问能够享受什么2023年1月份预计销售货物取得收入20万元，请问能够享受什么2023年1月份预计销售货物取得收入20万元，请问能够享受什么
			</div>
		</div> -->
		<div class="common_no_more" style="height: 248px">暂无内容~</div>
	</div>
</template>

<script>
	import {
		getSingleArticle
	} from '@/api/home/guild'
	export default {
		components: {

		},
		data() {
			return {
				
			}

		},
		mounted() {
			
		},
		methods: {
			
		}
	}
</script>

<style lang="scss" scoped>
	.xxwd {
		display: flex;
		align-items: center;
		margin-top: 20px;
		font-size: 14px;
	
		.yuan {
			width: 10px;
			height: 10px;
			border: 1px solid #333;
			border-radius: 50%;
			margin-right: 10px;
		}
	}
</style>
